export const SET_MFE_CONFIG_LIST = 'mfe/set-mfe-config-list';
export const ADD_MFE_CONFIG = 'mfe/add-mfe-config';
export const UPDATE_MFE_CONFIG = 'mfe/update-mfe-config';
